import {
  ListNotificationsFilterParameterPriorityEq as NotificationPriority,
  ListNotificationsFilterParameterStatusAnyOfInner as NotificationStatus
} from "@wingspanhq/wingspan-api-sdk";
import { WSNotificationResponse } from "../components/Notifications";

const priorityRank = (priority?: NotificationPriority): number => {
  if (priority === NotificationPriority.HIGH) return 0;
  if (priority === NotificationPriority.LOW) return 2;
  return 1;
};

export const selectorActiveNotifications = (
  responses: WSNotificationResponse[]
) => {
  return responses
    .filter(response => {
      return response.status !== NotificationStatus.DISMISSED;
    })
    .sort((a, b) => {
      return priorityRank(a.priority) - priorityRank(b.priority);
    });
};
